import * as Cookie from './cookie';

export const FormatearUrl = (nombre) => {
    if (nombre == undefined) {
        return "";
    }
    let res = nombre.trim().toLowerCase()
        .replace(/,/g, '')
        .replace(/\./g, '')
        .replace(/:/g, '-')
        .replace(/ /g, '-')
        .replace(/\)/g, '')
        .replace(/\(/g, '')
        .replace(/´/g, '')
        .replace(/"/g, '')
        .replace(/#/g, '')
        .replace(/&/g, '')
        .replace(/\//g, '')
        .replace(/\\/g, '')
        .replace(/\?/g, '')
        .replace(/!/g, '')
        .replace(/\*/g, '')
        .replace(/\[/g, '')
        .replace(/\]/g, '')
        .replace(/\{/g, '')
        .replace(/\}/g, '')
        .replace(/~/g, '')
        .replace(/'/g, '')
        .replace(/¨/g, '')
        .replace(/`/g, '')
        .replace(/\^/g, '')
        .replace(/_/g, '')
        .replace(/\+/g, '')
        .replace(/“/g,'')
        .replace(/%/g,'')
        .replace(/”/g,'');

    let replacement = [
        'a', 'a', 'a', 'a', 'a', 'a', 'c', 'e', 'e', 'e', 'e', 'i', 'i', 'i', 'i', 'n', 'o',
        'o', 'o', 'o', 'o', 'u', 'u', 'u', 'u', 'y', 'y'
    ];
    let accents =
    [
        'à', 'á', 'â', 'ã', 'ä', 'å', 'ç', 'é', 'è', 'ê', 'ë', 'ì', 'í', 'î', 'ï', 'ñ', 'ò', 'ó',
        'ô', 'ö', 'õ', 'ù', 'ú', 'û', 'ü', 'ý', 'ÿ'
    ];

    for (let i = 0; i < accents.length; i++) {
        res = res.replace(accents[i], replacement[i]);
    }

    return res;
}

export const formatoUrlAcuTag = (descripcion , id) => {

    return `/${FormatearUrl(descripcion)}-t${id}`;
}

export const formatoUrlAcuFotoTag = (descripcion , id) => {

    return `/fotos-de-${FormatearUrl(descripcion)}-f${id}`;
}

export const formatoUrlAcuAutor = (nombre , id) => {

    return `/autor/${FormatearUrl(nombre)}-${id}`;
}

 export const getRandomInteger = (min, max) => {
        let _min = Math.ceil(min);
        let _max = Math.floor(max+1);
        return Math.floor(Math.random() * (_max - _min)) + _min;
 }

export const getRandom = (data , hasta) => {
    {
        let arrayNotasRandom = [];
        let arraycount = data.length;
        let startIndex = 0;
        let endIndex = arraycount - 1;
        let loopTo = hasta;
        let dataRandom = [];

        if (endIndex < loopTo) loopTo = arraycount;

        for (let i = startIndex; i < loopTo; i++) {
            //Obtenego el primer numero random
            let _randomNumIndex = getRandomInteger(0, endIndex);

            //Cargo el numero random en el array
            arrayNotasRandom.push(_randomNumIndex);

            //Si no es el 1er numero y si esta en el array buscar otro numero
            if (arrayNotasRandom.length > 1 && jQuery.inArray(_randomNumIndex, arrayNotasRandom) > -1) {
                let exitwhile = 0;
                _randomNumIndex = getRandomInteger(0, endIndex);
                while (jQuery.inArray(_randomNumIndex, arrayNotasRandom) > -1 && exitwhile < 400) {
                    exitwhile++;
                    _randomNumIndex = getRandomInteger(0, endIndex);
                }
                arrayNotasRandom[i] = _randomNumIndex;
            }
        }

        for (let ir = 0; ir < arrayNotasRandom.length; ir++) {
            dataRandom.push(data[arrayNotasRandom[ir]]);
        }
     
        return dataRandom;
    }
}

export const scrolledIntoView = (elem) => {
    var element = $(elem);

    if (element.length > 0) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();
        
        var elemTop = element.offset().top;
        var elemBottom = elemTop + element.height();


        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }
    return false;

}

export const metaRefresh = (time , pagina) => {
    let productoPremiumId = Cookie.LeerCookie("ProductoPremiumId");
    if (productoPremiumId !== "") {
        productoPremiumId = productoPremiumId.replace(/ /g,"").split(",");
    }
    var objPlayers = document.getElementsByClassName("jwplayer");
    var objAudioPlayers = document.querySelectorAll("div.externo.audioboom");

    if (productoPremiumId.indexOf("5") < 0 || pagina === "home") {
        setInterval(function() {
            if (objPlayers.length > 0 || objAudioPlayers.length > 0) {
                let isPlaying = false;
                for (let i = 0; i < objPlayers.length; i++) {
                    if (jwplayer(i).getState() === "playing") {
                        isPlaying = true;
                        break;
                    }
                }

                if (objAudioPlayers.length > 0) isPlaying = true;

                if (!isPlaying) {
                    localStorage.setItem("CDmetaRefresh",true);
                    window.location.reload();
                }
            } else {
                localStorage.setItem("CDmetaRefresh",true);
                window.location.reload();
            }

        },time);
    }
}

export const getUrlSitios = (sitioId) => {

    switch (sitioId) {
        case 21:
            return "https://www.lanacion.com.ar/revista-ohlala-t50784";
        case 9:
            return "http://www.rollingstone.com.ar/";
        case 32:
            return "http://www.revistasusana.com/";
        default:
            return "https://www.lanacion.com.ar/";
    }
}

export const getTagPrioritario = (tagsNota, tagsConfigHome) => {

    if (tagsNota.length === 0) {
        return undefined;
    }
    //0 - Filtro notas con tags ocultos formatoId = 2
    tagsNota = tagsNota.filter(t => t.formatoId !== 2);
    //1 - Ordeno el array de tags prioritarios para la Home
    tagsConfigHome = tagsConfigHome.sort(sortArrayByObjProperty("prioridad"));
    //2 - Filtro los tags de la ESTA nota en base a los de la Home.
    tagsNota.filter(t => t.tipoId === tagsConfigHome.tagtipo);
    //3 - Si no hay ningun tag que conincida, retorno undefined para poder evitar la escritura del <a>
    if (tagsNota.length === 0) {
        return undefined;
    }
    //4 - Si hay mas de un tag de nota del mimso tipo, se discrimina por la prioridad DEL TAG DE LA NOTA y tomar el primero.
    const maxPrioridad = Math.min.apply(Math, tagsNota.map((tag) => { return tag.prioridad; }));    
    return tagsNota.filter(tag => tag.prioridad === maxPrioridad)[0];
}

export const sortArrayByObjProperty = (key, order = "asc") => {
    return function(a, b) {
        if (!a.hasOwnProperty(key) ||
            !b.hasOwnProperty(key)) {
            return 0;
        }

        const varA = (typeof a[key] === "string")
            ? a[key].toUpperCase()
            : a[key];
        const varB = (typeof b[key] === "string")
            ? b[key].toUpperCase()
            : b[key];

        let comparison = 0;
        if (varA > varB) {
            comparison = 1;
        } else if (varA < varB) {
            comparison = -1;
        }

        return ((order === "desc") ? (comparison * -1) : comparison
        );
    };
}

    









// WEBPACK FOOTER //
// ./Statics/scripts/common/utilities.js